import Hero from './hero'
import Photos from './photos'
import Members from './members'
import Info from './info'
import Collection from './collection'
import Reviews from './reviews'
import ApplyForms from './apply-forms'
import FloatPanel from './float-panel'
import ButtonGroups from './button-groups'
import Title from './title'
import ReadMoreText from 'components/common/read-more/text'
import Faq from 'components/common/intro/faq'

export default function StudioId({ studio, posts, reviews, applyForms }) {
  const t = useI18n()

  return (
    <div>
      <Hero studio={ studio } />

      <div className='container flex flex-row space-x-3 mb-16'>
        <div className='flex-1'>
          <ButtonGroups studioAccount={ studio.studioAccount }/>
          <Hr/>
          { !!studio.description && (<>
            <ReadMoreText className='text-sm' text={ studio.description } />
            <Hr />
          </>)}
          { !!studio.studioPhotos.length && (<>
            <Title>{ t('page:studioId.photo') }</Title>
            <Photos studio={ studio }/>
            <Hr />
          </>)}
          { !!studio.showableStylists.length && (<>
            <Title>{ t('page:studioId.stylist') }</Title>
            <Members studio={ studio } />
            <Hr />
          </>)}
          <div className='lg:hidden'>
            <Title>{ t('page:studioId.info') }</Title>
            <Info studio={ studio } />
            <Hr />
          </div>
          <Collection studio={ studio } posts={ posts }/>
          <Reviews studio={ studio } reviews={ reviews } />
          <ApplyForms applyForms={ applyForms } studioName={ studio.name }/>
        </div>
        <div className='hidden lg:block relative -translate-y-[100px] w-1/3 min-w-[16rem]'>
          <div className='sticky top-[12rem] bg-white opacity-95 p-5'>
            <Title>{ t('page:studioId.info') }</Title>
            <Info studio={ studio } />
          </div>
        </div>
      </div>
      <FloatPanel studioAccount={ studio.studioAccount }/>
      <div className='bg-gray-50'>
        <Faq />
      </div>
    </div>
  )
}

const Hr = () => (
  <div className='py-5'>
    <div className=''/>
  </div>
)
